import { useRoles } from "api/roles";
import { Breadcrumbs, TopHeader } from "components/Header/TopHeader/TopHeader";
import { useMessage } from "hooks/intl";
import { useLocation } from "react-router-dom";
import { links } from "utilities/links";
import { RoleForm } from "./RoleForm";
import { useStyles } from "./RoleForm.styles";

export function AddRole() {
  const classes = useStyles();
  const { message } = useMessage();
  const { state } = useLocation();
  const { useRoleData } = useRoles();
  const { data: roleData } = useRoleData(state?.duplicateRoleId);

  const breadcrumbs: Breadcrumbs = {
    parent: {
      label: message({ id: "roles" }),
      path: links.settings,
    },
  };

  const isDuplicationMode = state?.duplicateRoleId;
  const isLoading = isDuplicationMode && !roleData;

  const initialValues = roleData
    ? {
        name: `COPY - ${roleData.name}`,
        default: false,
        id: roleData.id,
        role: roleData.role,
        master: roleData.master,
        stores: roleData.stores,
        permissions: roleData.permissions,
      }
    : undefined;

  return (
    <>
      <TopHeader
        breadcrumbs={breadcrumbs}
        clearLink={links.settings}
        title={message({ id: "addRole" })}
      />
      <div className={classes.formWrapper}>
        {!isLoading && <RoleForm initialValues={initialValues} />}
      </div>
    </>
  );
}
